import { Text } from '@fluentui/react-components';

const NoPrograms: React.FC = () => {
  return (
    <Text data-testid="content" aria-live="polite">
      <div>There are no eligible programs available at this time.</div>
      <div>If you believe this may be an error, please reach out to customer support.</div>
    </Text>
  );
};

export default NoPrograms;
